import { type ProductRecommendationModel, ListItemDiscriminator } from 'autogen/swagger/all';
import type { ProductListItemModel } from 'autogen/swagger/all';

// helper for manipulating size of items array, before they are displayed in the grid
// biome-ignore lint/style/useDefaultParameterLast: <explanation>
export const getPrettifiedGrid = (items: ProductListItemModel[], columns = 2, rowsPerLevel = 2, level: number) => {
    const currentNumberOfitems = items.length;
    const itemsPerLevel = columns * rowsPerLevel;
    const currMaximumVisibleItems = itemsPerLevel * level;

    if (currentNumberOfitems <= columns) return items;

    // if there is enough items for one row but not enough for a second row, get the lowest number of items that is divisible by the column number. ( if level > 1 means the user has clicked see more items btn)
    if (currentNumberOfitems > columns && currentNumberOfitems < itemsPerLevel && level === 1) {
        if (!Number.isInteger(currentNumberOfitems / columns)) {
            const newShortenedItems = items.slice(0, Math.floor(currentNumberOfitems / columns) * columns);
            return newShortenedItems;
        }
    }

    // if there is more items than we are max able to show, shortend array to the max number.
    if (currentNumberOfitems > currMaximumVisibleItems) {
        const newShortenedItems = items.slice(0, currMaximumVisibleItems);
        return newShortenedItems;
    }

    return items;
};

export const filterProductRecommendationItems = (
    recommendationModel: ProductRecommendationModel,
    uaTrackingCategory
): ProductListItemModel[] =>
    recommendationModel.products.reduce<ProductListItemModel[]>((acc, currentVal) => {
        const productListItem = ListItemDiscriminator(
            currentVal,
            () => null, // should not be in productRecommendation
            () => null, // should not be in productRecommendation
            (model) => model, // ProductListItemModel
            () => null // should not be in productRecommendation
        );
        if (productListItem) {
            productListItem.uaTrackingCategory = uaTrackingCategory;
            acc.push(productListItem);
        }
        return acc;
    }, []);
